import S50 from './Img/robots/S50.jpg';
import S100 from './Img/robots/S100.jpg';
import S200 from './Img/robots/S200.jpg';
import S300 from './Img/robots/S300.jpg';
import S400 from './Img/robots/S400.jpg';
import PoolUp from './Img/robots/Pool-Up.jpg';
import E10 from './Img/robots/E10.jpg';
import E20 from './Img/robots/E20.jpg';
import M600 from './Img/robots/M600.jpg';
import M700 from './Img/robots/M700.jpg';
import Wave30 from './Img/robots/Wave-30.jpg';
import Pro from './Img/robots/Pro-x2-.jpg';
import Prox2 from './Img/robots/Pro-2x2.jpg';

function Robots() {

  return (
    <><br/><br/><br/><br/><br/>
    <div class="row p-2 ms-5 me-5 border-0 principalrow">
    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={S50} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin S50</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 8 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">12 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={S100} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin S100</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 10 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">15 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={S200} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin S200</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 12 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={S300} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin S300</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 12 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">Sí</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={S400} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin S400</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 15 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">Sí</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={PoolUp} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin Pool Up</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 8 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">12 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={E10} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin E-10</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 8 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">12 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={E20} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin E-20</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 10 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">15 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">No</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={M600} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin M-600</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 15 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">Sí</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={M700} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin M-700</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 15 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">Sí</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={Wave30} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin Wave-30</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 15 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">18 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={Pro} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin Pro x2 Combinado</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 25 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">30 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12 mb-4">
        <div class="card"><img src={Prox2} class="card-img-top ps-5 pe-5"
                alt="..."/>
            <div class="card-body body-robots">
                <h5 class="card-title text-center robot">Dolphin 2x2 Combinado</h5>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Metros de la piscina:</div>
                    <div class="col-6">Hasta 50 metros</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Longitud del cable:</div>
                    <div class="col-6">40 metros</div>
                </div>
                <div class="row bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Limpieza de paredes:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row p-1">
                    <div class="col-6">Cepilla línea de flotación:</div>
                    <div class="col-6">Sí</div>
                </div>
                <div class="row  bg-secondary bg-opacity-25 p-1">
                    <div class="col-6">Smartphone app control:</div>
                    <div class="col-6">No</div>
                </div>
            </div>
        </div>
    </div>
</div>
    </>
  )
}

export default Robots